module.exports = __webpack_public_path__ + "static/media/purcari.ecc46a2b.png";